import { createFeatureSelector } from '@ngrx/store';
import type { AddressCheckResult } from '@essent/address';
import { type AsyncState } from '@essent/common';

export const addressFormSelectorKey = 'eplus-address-check';

export const addressFormFeature = createFeatureSelector<AddressFormState>(
  addressFormSelectorKey
);

export interface AddressFormState {
  addressCheck: AsyncState<AddressCheckResult>;
  selectedPostalCode?: {
    postcode: string;
    houseNumber: string;
    houseNumberAddition?: string;
  };
}
